import type { RootState } from '@/store';

const selectSelf = (state: RootState) => state.notificacaoSelf;

export const selectSelfStep = (state: RootState) => selectSelf(state).step;
export const selectSelfForm = (state: RootState) => selectSelf(state).form;
export const selectSelfMedicaoAutorizada = (state: RootState) =>
  selectSelf(state).medicaoAutorizada;
export const selectSelfCnpjStatus = (state: RootState) => selectSelf(state).cnpjStatus;
export const selectSelfCnpjErro = (state: RootState) => selectSelf(state).cnpjErro;
export const selectSelfPlanos = (state: RootState) => selectSelf(state).planos;
export const selectSelfCarregandoPlanos = (state: RootState) => selectSelf(state).carregandoPlanos;
export const selectSelfPlanosErro = (state: RootState) => selectSelf(state).planosErro;
export const selectSelfEnviandoCadastro = (state: RootState) => selectSelf(state).enviandoCadastro;
export const selectSelfCadastroErro = (state: RootState) => selectSelf(state).cadastroErro;
export const selectSelfLeadId = (state: RootState) => selectSelf(state).leadId;
export const selectSelfAccessToken = (state: RootState) => selectSelf(state).accessToken;
export const selectSelfPlanoTier = (state: RootState) => selectSelf(state).planoTier;
export const selectSelfPagamentoStatus = (state: RootState) => selectSelf(state).pagamentoStatus;
export const selectSelfPagamentoErro = (state: RootState) => selectSelf(state).pagamentoErro;
export const selectSelfIniciandoPagamento = (state: RootState) =>
  selectSelf(state).iniciandoPagamento;
export const selectSelfPagamentoIniciado = (state: RootState) =>
  selectSelf(state).pagamentoIniciado;
export const selectSelfInvoiceUrl = (state: RootState) => selectSelf(state).invoiceUrl;
export const selectSelfConsultandoPagamento = (state: RootState) =>
  selectSelf(state).consultandoPagamento;
export const selectSelfPollingPagamentoExpirado = (state: RootState) =>
  selectSelf(state).pollingPagamentoExpirado;
export const selectSelfSessaoExpirada = (state: RootState) => selectSelf(state).sessaoExpirada;
